import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-198a00da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_2 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_3 = { class: "mainContainer" }
const _hoisted_4 = { class: "videoContainer" }
const _hoisted_5 = { class: "imageContainer" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "buttonContainer" }
const _hoisted_8 = { class: "photo-validation-error" }
const _hoisted_9 = { class: "validationContainer" }
const _hoisted_10 = { class: "result-icon" }
const _hoisted_11 = { class: "info-icon" }
const _hoisted_12 = { class: "result-icon" }
const _hoisted_13 = { class: "info-icon" }
const _hoisted_14 = { class: "result-icon" }
const _hoisted_15 = { class: "info-icon" }
const _hoisted_16 = { class: "result-icon" }
const _hoisted_17 = { class: "info-icon" }
const _hoisted_18 = {
  ref: "canvas",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.title)), 1),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.description)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_inner_loading, {
        showing: !_ctx.videoReady
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_spinner, {
            size: "50px",
            color: "primary"
          })
        ]),
        _: 1
      }, 8, ["showing"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("video", {
          ref: "video",
          style: _normalizeStyle(_ctx.photoStyle),
          playsinline: "",
          onCanplay: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initCanvas()))
        }, "Stream Unavailable", 36)
      ], 512), [
        [_vShow, !_ctx.videoHidden]
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showPhoto)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              id: "imgPhoto",
              src: _ctx.portal.photoData,
              style: _normalizeStyle(_ctx.photoStyle)
            }, null, 12, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.videoReady && !_ctx.showPhoto)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              color: "primary",
              "text-color": "white",
              icon: "camera_enhance",
              label: _ctx.$t('portal_takePhoto'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.takePicture()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.showPhoto && _ctx.validationCompleted)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              color: "primary",
              "text-color": "white",
              label: _ctx.$t('portal_resetPhoto'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPhoto()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, "Validation Failed", 512), [
      [_vShow, _ctx.validationError]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_10, [
          (_ctx.validationCompleted && _ctx.faceNotRotated)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "check_circle",
                color: "green",
                size: "1rem"
              }))
            : _createCommentVNode("", true),
          (_ctx.validationCompleted && !_ctx.faceNotRotated)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "cancel",
                color: "red",
                size: "1rem"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('portal_faceNotRotated')), 1),
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_q_icon, {
            name: "info",
            color: "grey",
            size: "1rem"
          }),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portal_faceNotRotatedTooltip')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_12, [
          (_ctx.validationCompleted && _ctx.faceCloseToFrame)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "check_circle",
                color: "green",
                size: "1rem"
              }))
            : _createCommentVNode("", true),
          (_ctx.validationCompleted && !_ctx.faceCloseToFrame)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "cancel",
                color: "red",
                size: "1rem"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('portal_faceCloseToFrame')), 1),
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_q_icon, {
            name: "info",
            color: "grey",
            size: "1rem"
          }),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portal_faceCloseToFrameTooltip')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_14, [
          (_ctx.validationCompleted && _ctx.faceCentreAligned)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "check_circle",
                color: "green",
                size: "1rem"
              }))
            : _createCommentVNode("", true),
          (_ctx.validationCompleted && !_ctx.faceCentreAligned)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "cancel",
                color: "red",
                size: "1rem"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('portal_faceCenterAligned')), 1),
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_q_icon, {
            name: "info",
            color: "grey",
            size: "1rem"
          }),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portal_faceCenterAlignedTooltip')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_16, [
          (_ctx.validationCompleted && _ctx.whiteBackground)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "check_circle",
                color: "green",
                size: "1rem"
              }))
            : _createCommentVNode("", true),
          (_ctx.validationCompleted && !_ctx.whiteBackground)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "cancel",
                color: "red",
                size: "1rem"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('portal_whiteBackground')), 1),
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_q_icon, {
            name: "info",
            color: "grey",
            size: "1rem"
          }),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portal_whiteBackgroundTooltip')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.validationHidden]
    ]),
    _createElementVNode("canvas", _hoisted_18, null, 512)
  ], 64))
}